<script lang="ts" setup>
import Card from 'primevue/card'
import FormSection from '@/components/forms/FormSection.vue'
import FormInputText from '@/components/inputs/FormInputText.vue'
import FormDropdown from '@/components/inputs/FormDropdown.vue'
import {  computed  } from 'vue'
import { type Customer } from '@/types/customer-types'
import { RouterLink } from 'vue-router'


const props = defineProps<{
  values: any
  type: 'add' | 'edit' | 'view'
  onSubmit: () => void
  setErrors: (errors: any) => void
  customerList: Customer[]
}>()

const isViewPage = computed<boolean>(() => props.type === 'view')
const isAddPage = computed<boolean>(() => props.type === 'add')

const activeCustomerList = computed(() => {
  return props.customerList.filter((customer: Customer) => customer.isActive !== false)
})

const deliveryAddresses = computed(() => {
  const selectedCustomer = props.customerList.find((customer: { id?: string }) =>
      customer.id === props.values?.customerId
  )
  return selectedCustomer?.addresses?.filter((address: any) =>
      address.addressType === 1
  ) || []
})

const invoiceAddresses = computed(() => {
  const selectedCustomer = props.customerList.find((customer: { id?: string }) =>
      customer.id === props.values?.customerId
  )
  return selectedCustomer?.addresses?.filter((address: any) =>
      address.addressType === 0
  ) || []
})

const formattedDeliveryAddresses = computed(() => {
  return deliveryAddresses.value.map((address: any) => ({
    ...address,
    label: [address.line1, address.line2, address.city, address.region, address.postCode, address.country]
        .filter(Boolean).join(', ')
  }))
})

const formattedInvoiceAddresses = computed(() => {
  return invoiceAddresses.value.map((address: any) => ({
    ...address,
    label: [address.line1, address.line2, address.city, address.region, address.postCode, address.country]
        .filter(Boolean).join(', ')
  }))
})
</script>

<template>
  <form @submit.prevent="onSubmit" class=" !rounded-t-3xl">
    <Card>
      <template #content>
        <div class="">
          <FormSection
              title="Customer Details"
              description=""
          >
            <div v-if="isViewPage">
              <label class="text-neutral-500 text-sm mb-1 flex gap-x-1" for="customerId">Customer Name</label>
              <p class="py-2 font-medium text-[15px] bg-gray-50 rounded-lg px-2">
                <RouterLink
                    :to="`/customers/${values.customerId}`"
                    class="font-medium text-neutral-800 hover:underline"
                >
                  {{ customerList.find(c => c.id === values.customerId)?.businessName }}
                </RouterLink>
              </p>
            </div>
            <FormDropdown
                v-else
                label="Customer Name"
                inputName="customerId"
                id="customerId"
                :options="activeCustomerList"
                optionLabel="businessName"
                optionValue="id"
                :viewOnly="false"
            />
            <FormInputText
                :viewOnly="isViewPage"
                label="Customer Purchase Order Number"
                inputName="customerPurchaseOrderNumber"
                id="customerPurchaseOrderNumber"
            />
            <FormDropdown
                label="Delivery Address"
                inputName="deliveryAddress"
                id="deliveryAddress"
                :options="formattedDeliveryAddresses"
                optionLabel="label"
                optionValue="id"
                :viewOnly="isViewPage"
            />
            <FormDropdown
                label="Invoice Address"
                inputName="invoiceAddress"
                id="invoiceAddress"
                :options="formattedInvoiceAddresses"
                optionLabel="label"
                optionValue="id"
                :viewOnly="isViewPage"
            />
          </FormSection>
        </div>
      </template>
    </Card>
  </form>
</template>
